// removed by extract-text-webpack-plugin
module.exports = {"InputElement":"InputAuth__-loca-__qigYB","InnerElements":"InputAuth__-loca-__2QbQX","ValidationError":"InputAuth__-loca-__17vVT","InputWrapper":"InputAuth__-loca-__Fs92x","InputPassWrapper":"InputAuth__-loca-__3Q3Dv","Password":"InputAuth__-loca-__3rs51","PasswordWrapper":"InputAuth__-loca-__3WgPS","CheckBox":"InputAuth__-loca-__kfQ3k","Checkmark":"InputAuth__-loca-__3dYnh","CheckBoxSection":"InputAuth__-loca-__I0lU7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/InputAuth/InputAuth.css
// module id = 251
// module chunks = 0